/**
 * Figma "Star 1" — 5-point star ambient glow.
 * Path + feGaussianBlur(180) from Figma; fill uses primary at 0.15 opacity.
 * SVG scales to the content area so the star isn't clipped into a circular blob.
 */
import { useId } from 'react';
import { useLocation } from 'react-router-dom';

import { isConfigureRoute } from 'constant/configure-nav';
import { cn } from 'lib/utils';

/** SVG viewBox includes blur padding (stdDeviation 180). */
const SVG_WIDTH = 2520;
const SVG_HEIGHT = 1842;
/** Figma horizontal nudge as a fraction of the star frame (70.5 / 1800). */
const STAR_NUDGE_X = '3.9%';

const STAR_PATH =
  'M1227.14 395.353L1318.7 674.574L2160 360L1375.28 848.659L1682.82 1276.95L1227.14 956.25L635.679 1482L1079.01 848.659L360 360L1135.59 674.574L1227.14 395.353Z';

export function BrandAmbientGlow() {
  const { pathname } = useLocation();
  const filterId = `brand-star-glow-${useId().replace(/:/g, '')}`;
  const isConfigure = isConfigureRoute(pathname);

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 z-[1] overflow-hidden"
    >
      <svg
        className={cn(
          'absolute left-1/2 h-auto w-[min(100%,1800px)] max-w-none -translate-x-1/2 -translate-y-1/2 dark:hidden',
          isConfigure ? 'top-[72%]' : 'top-[68%]'
        )}
        style={{ marginLeft: STAR_NUDGE_X }}
        viewBox={`0 0 ${SVG_WIDTH} ${SVG_HEIGHT}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <filter
            id={filterId}
            x="0"
            y="0"
            width={SVG_WIDTH}
            height={SVG_HEIGHT}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="180" result="effect1_foregroundBlur" />
          </filter>
        </defs>
        <g opacity="0.15" filter={`url(#${filterId})`}>
          <path d={STAR_PATH} fill="rgb(var(--primary-shadow-rgb))" />
        </g>
      </svg>
    </div>
  );
}

/** Figma dark-mode grid overlay on authenticated screens */
export function DarkModeGridOverlay() {
  return (
    <div
      aria-hidden="true"
      className="dark-mode-grid-overlay pointer-events-none absolute inset-0 z-[1] hidden dark:block"
    />
  );
}
